import React from 'react'
import { Col, Grid, Row, Skeleton } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Billing/subcomponents/Placeholder/Placeholder.module.scss'

const Placeholder = () => {
  const breakpoints = useBreakpoint()

  return (
    <Skeleton shown className={styles.skeleton}>
      {/* PageHeader */}
      <div className={'layout-tile margin-bottom-16'}>
        <Row className={styles.skeleton__row}>
          <Col
            className={styles.skeleton__line}
            style={{ width: breakpoints.md ? '30%' : '60%', height: breakpoints.md ? 40 : 28 }}
            sm="auto"
          />
        </Row>
      </div>

      {/* Payment Methods */}
      <div className={'layout-tile margin-bottom-16'}>
        <Grid>
          <Row className={styles.skeleton__row} style={{ marginBottom: 24 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: breakpoints.md ? '47%' : '75%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Grid gap={13} style={{ marginBottom: 12 }}>
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            <Col
              s={6}
              md={3}
              className={styles.skeleton__line}
              style={{ height: 70 }}
            />
            {breakpoints.md && (
              <>
                <Col
                  s={6}
                  md={3}
                  className={styles.skeleton__line}
                  style={{ height: 70 }}
                />
                <Col
                  s={6}
                  md={3}
                  className={styles.skeleton__line}
                  style={{ height: 70 }}
                />
              </>
            )}
          </Grid>
        </Grid>
      </div>

      {/* Form fields & buttons */}
      <div className={'layout-tile'}>
        <Grid>
          <Row className={styles.skeleton__row} style={{ marginBottom: 56 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          <Row className={styles.skeleton__row} style={{ marginBottom: 112 }}>
            <Col
              className={styles.skeleton__line}
              style={{ width: '100%', height: 19 }}
              sm="auto"
            />
          </Row>
          {breakpoints.md ? (
            <>
              <Row
                className={styles.skeleton__row}
                style={{ marginBottom: 20 }}
                justifyContent="between"
              >
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '21%', height: 19 }}
                  sm="auto"
                />
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '36%', height: 19 }}
                  sm="auto"
                />
              </Row>
              <Row
                className={styles.skeleton__row}
                style={{ marginBottom: 61 }}
                justifyContent="end"
              >
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '21%', height: 19 }}
                  sm="auto"
                />
              </Row>
              <Row className={styles.skeleton__row} justifyContent="between">
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '37%', height: 54 }}
                  sm="auto"
                />
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '59%', height: 54 }}
                  sm="auto"
                />
              </Row>
            </>
          ) : (
            <>
              <Row
                className={styles.skeleton__row}
                justifyContent="end"
                style={{ marginBottom: 20 }}
              >
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '58%', height: 19 }}
                  sm="auto"
                />
              </Row>
              <Row
                className={styles.skeleton__row}
                justifyContent="end"
                style={{ marginBottom: 87 }}
              >
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '34%', height: 19 }}
                  sm="auto"
                />
              </Row>
              <Row className={styles.skeleton__row} style={{ marginBottom: 22 }}>
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '100%', height: 54 }}
                  sm="auto"
                />
              </Row>
              <Row className={styles.skeleton__row} style={{ marginBottom: 22 }}>
                <Col
                  className={styles.skeleton__line}
                  style={{ width: '100%', height: 54 }}
                  sm="auto"
                />
              </Row>
            </>
          )}
        </Grid>
      </div>
    </Skeleton>
  )
}

export default Placeholder
